import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import moment from 'moment'

import {
  toWeekInt,
  toWeekString,
  toWeekStartDate
} from '../../../helpers/moment'

import { config } from '../../../config/index'
const { API_URL } = config

const TotalHours = ({
  activeClient,
  activeDate,
  activeWeek,
  totalHours,
  activeSchedules
}) => {
  const token = localStorage.getItem('token')
  const user = JSON.parse(localStorage.getItem('user'))

  const padding = 90 // adjust this to your needs
  let height = 375 + padding
  let heightPx = height + 'px'
  let heightOffset = height / 2
  let offsetPx = heightOffset + 'px'

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '90%'
  }

  const [showModal, setShowModal] = useState(false)
  const [scores, setScores] = useState({})

  const handleOpenModal = () => setShowModal(true)
  const handleCloseModal = () => setShowModal(false)

  useEffect(() => {
    const fetchAssociatePerformance = async () => {
      let url = `${API_URL}/associate/myperformance`

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8'
          }
        })

        let json = await response.json()

        if (json.success) {
          let filtered =
            json.data.length > 0
              ? json.data.find(
                  performance =>
                    performance.week_start_date ===
                    moment(activeWeek.startDate).format('YYYY-MM-DD')
                )
              : {}
          setScores(filtered)
        } else {
          console.log(json.message)
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchAssociatePerformance()
  }, [token, activeDate, activeWeek])

  return (
    <React.Fragment>
      <div className="container py-2 d-flex flex-column bg-white">
        <div className="pb-2 d-flex justify-content-center align-content-center">
          <div>
            <i className="fas fa-clock grey" style={{ width: '30px' }} />
          </div>
          <div
            className="text-left flex-grow-1 "
            style={{ color: 'rgb(125,125,125)' }}
          >
            Total hours this week:{' '}
            <span className="total-hours-number">
              {totalHours}/
              {activeClient && activeClient.max_hours.length > 0
                ? activeClient.max_hours.find(
                    week =>
                      week.start_date ===
                      toWeekStartDate(
                        moment(activeDate),
                        activeClient.start_day
                      ).format('YYYY-MM-DD')
                  )
                  ? activeClient.max_hours.find(
                      week =>
                        week.start_date ===
                        toWeekStartDate(
                          moment(activeDate),
                          activeClient.start_day
                        ).format('YYYY-MM-DD')
                    ).hours
                  : 0
                : 0}
            </span>
          </div>
        </div>
        <div className="pb-2 d-flex justify-content-center align-content-center">
          <div>
            <i
              className="fas fa-tachometer-alt grey"
              style={{ width: '30px' }}
            />
          </div>
          <div
            className="text-left flex-grow-1"
            onClick={handleOpenModal}
            style={{ color: 'rgb(125,125,125)' }}
          >
            View performance score
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={showModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style
        }}
      >
        <div className="d-flex flex-column h-100">
          <div className="text-center">
            <h5>Performance Score</h5>
            {activeClient && (
              <h5 className="text-muted">
                Week{' '}
                {toWeekInt(
                  moment(activeWeek.startDate),
                  activeClient.start_day
                )}{' '}
                (
                {toWeekString(
                  moment(activeWeek.startDate),
                  activeClient.start_day
                )}
                )
              </h5>
            )}
          </div>
          {scores && scores.attendance_rate ? (
            <div
              className="table-responsive border rounded mt-2"
              style={{ fontSize: '0.8rem' }}
            >
              <table className="table table-borderless m-0">
                <thead className="border-bottom">
                  <tr>
                    <th className="border-right">
                      Week{' '}
                      {toWeekInt(activeWeek.startDate, activeClient.start_day)}
                    </th>
                    <th className="border-right">Weightage</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border-right font-weight-bold">
                      Attendance Rate
                    </td>
                    <td className="border-right text-center">35%</td>
                    <td className="text-center">{scores.attendance_rate}%</td>
                  </tr>
                  <tr>
                    <td className="border-right font-weight-bold">Fill Rate</td>
                    <td className="border-right text-center">35%</td>
                    <td className="text-center">{scores.fill_rate}%</td>
                  </tr>
                  <tr>
                    <td className="border-right font-weight-bold">Pick Rate</td>
                    <td className="border-right text-center">30%</td>
                    <td className="text-center">{scores.pick_rate}%</td>
                  </tr>
                  <tr className="border-top">
                    <td
                      colSpan="2"
                      className="border-right text-right font-weight-bold"
                    >
                      Overall
                    </td>
                    <td className="text-center">{scores.performance_score}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <div className="container text-center">
              <i className="text-muted">
                Pick Rates can be uploaded once the week has ended.
              </i>
            </div>
          )}
          <button
            className="btn btn-brand btn-block mt-auto"
            onClick={handleCloseModal}
          >
            Close
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default TotalHours
